import * as React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    YouDecideHeaderWrapper,
    YouDecideLabel,
    YouDecideDescription,
    YouDecideDescriptionContainer,
    YouDecideCashOutText,
    YouDecideDescWrapper,
    RabBuildAbetIconWrapper,
} from './YouDecideHeader.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const YouDecideHeader = (): JSX.Element => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;

    return (
        <YouDecideHeaderWrapper data-test='rab-header-wrapper'>
            <RabBuildAbetIconWrapper />
            <YouDecideDescWrapper>
                <YouDecideLabel>{config.rabHeaderTitle}</YouDecideLabel>
                <YouDecideDescriptionContainer>
                    <YouDecideDescription data-test='create-your-own-bet-text'>
                        <I18n
                            langKey='you-decide.header.create-bet.info'
                            defaultText='Create your own bet'
                        />
                    </YouDecideDescription>
                    {config.rabCashoutAvailable === true ? (
                        <YouDecideCashOutText data-test='unavailable-for-cashout-text'>
                            (
                            <I18n
                                langKey='you-decide.header.create-bet.cashout-info'
                                defaultText='Unavailable for cashout'
                            />
                            )
                        </YouDecideCashOutText>
                    ) : null}
                </YouDecideDescriptionContainer>
            </YouDecideDescWrapper>
        </YouDecideHeaderWrapper>
    );
};
